import { useState } from "react";
import { useOnboardingStep } from "../hooks/useOnboardingStep";
import { OnboardingMatchingIntro } from "../components/OnboardingMatchingIntro/OnboardingMatchingIntro";
import { OnboardingQuizContainer } from "../components/OnboardingQuizContainer/OnboardingQuizContainer";

export function OnboardingMatchingQuizPage() {
  const [isQuizStarted, setIsQuizStarted] = useState(false);

  const { completeStep } = useOnboardingStep();

  const handleStartQuiz = () => {
    setIsQuizStarted(true);
    completeStep("matching-intro");
  };

  return (
    <>
      {isQuizStarted ? (
        <OnboardingQuizContainer stepName="matching" />
      ) : (
        <OnboardingMatchingIntro onStart={handleStartQuiz} />
      )}
    </>
  );
}

export default OnboardingMatchingQuizPage;
